import { createRoot } from 'react-dom/client';

// styles
import './index.scss';

// project-imports
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';

import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';

const container = document.getElementById('root');

// En prod silenciamos los reportes de errores que React hace a consola por
// default (onCaughtError/onUncaughtError llegaron en React 19). En dev sí
// queremos verlos para debuggear.
const isDev = import.meta.env.DEV;
const root = createRoot(
  container!,
  isDev ? undefined : { onCaughtError: () => {}, onUncaughtError: () => {}, onRecoverableError: () => {} },
);

root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);
